import { computed } from 'vue'

import { EventDetailId } from '@collector/sportsapi-client-legacy'

import {
  EventDurationConfig,
  GetEventClockSeconds,
  GetEventClockTime,
  GetEventStatusPeriodLengthMinutes,
  IsValidEventClockTime,
} from '../../configuration'
import { provideEventDurationConfig } from '../eventDurationConfig'
import {
  useEventCurrentPeriodLength,
  useInitEventClock,
  useTimerDirection,
} from './composables'
import { provideEventClock } from './eventClock'
import { provideEventClockHelpers } from './eventClockHelpers'

export type Clock = {
  timerDirectionEventDetailId?: EventDetailId
  getEventStatusPeriodLengthMinutes: GetEventStatusPeriodLengthMinutes
  getEventPeriodStartOffsetMinutes?: GetEventStatusPeriodLengthMinutes
  isValidEventClockTime: IsValidEventClockTime
  getEventClockTime: GetEventClockTime
  getEventClockSeconds: GetEventClockSeconds
  maxPeriodLengthMinute?: boolean
  minutesMaxDigits: number
  eventDurationConfig?: EventDurationConfig
  extraTimeDetailId?: EventDetailId
}

export function provideClock(params: Clock): void {
  if (params.eventDurationConfig) {
    provideEventDurationConfig(params.eventDurationConfig)
  }

  const {
    currentPeriodLengthMinutes,
    currentPeriodStartOffsetMinutes,
    extraTimePlayed,
  } = useEventCurrentPeriodLength(
    params.getEventStatusPeriodLengthMinutes,
    params.extraTimeDetailId,
    params.getEventPeriodStartOffsetMinutes,
  )

  const isTimerDirectionDown = params.timerDirectionEventDetailId
    ? useTimerDirection(params.timerDirectionEventDetailId)
    : computed(() => false)

  provideEventClockHelpers({
    currentPeriodLengthMinutes,
    currentPeriodStartOffsetMinutes,
    isTimerDirectionDown,
    isValidEventClockTime: params.isValidEventClockTime,
    getEventClockTime: params.getEventClockTime,
    minutesMaxDigits: params.minutesMaxDigits,
  })

  const maxMinute = params.maxPeriodLengthMinute
    ? computed(() => {
        if (currentPeriodLengthMinutes.value === null) {
          throw Error('unsupported currentPeriodLengthMinutes: null')
        }

        return currentPeriodLengthMinutes.value
      })
    : undefined

  const eventClock = useInitEventClock({
    currentPeriodLengthMinutes,
    currentPeriodStartOffsetMinutes,
    extraTimePlayed,
    isTimerDirectionDown,
    getEventClockSeconds: params.getEventClockSeconds,
    getEventClockTime: params.getEventClockTime,
    maxMinute,
  })

  provideEventClock(eventClock)
}
